(() => {
    const up = document.querySelector('.j-up-button');

    if (up) {
        const check = () => {
            if (window.scrollY <= 200) {
                up.style.display = 'none';
            } else {
                up.style.display = 'flex';
            }
        };

        check();

        up.addEventListener('click', () => {
            window.scrollTo({
                top     : 0,
                left    : 0,
                behavior: 'smooth'
            });
        });

        window.addEventListener('scroll', () => {
            check();
        });
    }
})();
